import React from 'react';

// project imports
// import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import { useGetMenuMaster } from 'api/menu';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent: React.FC = () => {
  const { menuMaster } = useGetMenuMaster();

  // Defensive fallback in case menuMaster is undefined
  const drawerOpen =  false;

  return (
    <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
      <Navigation />
      {/* {drawerOpen && <NavCard />} */}
    </SimpleBar>
  );
};

export default DrawerContent;
